// ** React Imports
import { lazy } from 'react'

const Camino           = lazy(() => import('../../views/pages/resultados/camino'))
const Niveles           = lazy(() => import('../../views/pages/resultados/camino/niveles'))
const Retos            = lazy(() => import('../../views/pages/resultados/retos'))
const Eventos          = lazy(() => import('../../views/pages/resultados/eventos'))
const Insignias        = lazy(() => import('../../views/pages/resultados/insignias'))
const Productividad    = lazy(() => import('../../views/pages/resultados/productividad'))
const Equivalencias    = lazy(() => import('../../views/pages/resultados/equivalencias'))

const ReporteSISE      = lazy(() => import('../../views/pages/resultados/reporteSISE'))
const PrimaPagada      = lazy(() => import('../../views/pages/resultados/primaPagada'))
const PremiosOtorgados = lazy(() => import('../../views/pages/resultados/premios-otorgados'))
const CatCompanias     = lazy(() => import('../../views/pages/resultados/catalogos/companias'))
const CatPremios       = lazy(() => import('../../views/pages/resultados/catalogos/premios'))
const CatTipoActividades = lazy(() => import('../../views/pages/resultados/catalogos/tipo-actividades'))
const CatTipoRetos     = lazy(() => import('../../views/pages/resultados/catalogos/tipo-retos'))
const Ramos            = lazy(() => import('../../views/pages/resultados/catalogos/ramos'))
const Productos        = lazy(() => import('../../views/pages/resultados/productos'))
const FormFactory        = lazy(() => import('../../views/pages/formfactory'))
const Robot            = lazy(() => import('../../views/pages/robot'))

const ResultadosRoutes = [
  {
    element: <Retos />,
    path: '/resultados/retos',
    meta: {
      appLayout: false,
      className: 'book-open'
    }
  },
  {
    element: <PrimaPagada />,
    path: '/reportes/prima-pagada',
    meta: {
      appLayout: false,
      className: 'book-open'
    }
  },
  {
    element: <ReporteSISE />,
    path: '/reportes/SISE',
    meta: {
      appLayout: false,
      className: 'book-open'
    }
  },
  {
    element: <Camino />,
    path: '/resultados/camino',
    meta: {
      appLayout: false,
      className: 'book-open'
    }
  },
  {
    element: <Niveles />,
    path: '/resultados/niveles',
    meta: {
      appLayout: false,
      className: 'book-open'
    }
  },
  {
    element: <Equivalencias />,
    path: '/resultados/equivalencias',
    meta: {
      appLayout: false,
      className: 'book-open'
    }
  },
  {
    element: <CatCompanias />,
    path: '/resultados/catalogos/companias',
    meta: {
      appLayout: false,
      className: 'book-open'
    }
  },
  {
    element: <CatPremios />,
    path: '/resultados/catalogos/premios',
    meta: {
      appLayout: false,
      className: 'book-open'
    }
  },
  {
    element: <Ramos />,
    path: '/resultados/catalogos/ramos',
    meta: {
      appLayout: false,
      className: 'book-open'
    }
  },
  {
    element: <CatTipoActividades />,
    path: '/resultados/catalogos/tipos-actividades',
    meta: {
      appLayout: false,
      className: 'book-open'
    }
  },
  {
    element: <CatTipoRetos />,
    path: '/resultados/catalogos/tipos-retos',
    meta: {
      appLayout: false,
      className: 'book-open'
    }
  },
  {
    element: <Productos />,
    path: '/resultados/productos',
    meta: {
      appLayout: false,
      className: 'book-open'
    }
  },
  {
    element: <FormFactory />,
    path: '/dev/formfactory',
    meta: {
      appLayout: false,
      validPermission : false,
      className: 'book-open'
      
    }
  }
]

export default ResultadosRoutes
